import React from "react";
import { Row, Col } from "react-bootstrap";
import {
  AnalyticFilter,
  HorizontalBarChart,
  AnalyticWidget,
  LineCharts,
  ProductStatus,
} from "shared/product-chart";
import ProductsBreadcrumb from "shared/components/ProductsBreadcrumb";

export default function StartupProductChart(props) {
  const {
    product,
    averageSalesCountPerStorePerWeek,
    absoluteSalesCount,
    absoluteSalesRevenue,
    absoluteSellingMerchantStoreCount,
    salesDataInfo,
    averageSalesCountPerStorePerWeekChartData,
    absoluteSalesCountPerStorePerWeekChartData,
    absoluteSalesCountPerStorePerWeek,
    averageSalesRevenuePerStorePerWeekChartData,
    averageSalesRevenuePerStorePerWeek,
    averageSalesCountPerRegionChartData,
    absoluteSalesCountPerRegionChartData,
  } = props;

  return (
    <div id="startup-product-chart">
      <ProductsBreadcrumb product={product} productsPath="/startups/products" />

      <ProductStatus productName={product.name} salesDataInfo={salesDataInfo} />

      <AnalyticFilter
        productId={product.id}
        chartUrl={`/startups/products/${product.id}/chart`}
      />

      <br />

      <Row>
        <AnalyticWidget
          icon="tags"
          value={averageSalesCountPerStorePerWeek}
          label="ø Abverkauf pro Markt pro Woche"
        />
        <AnalyticWidget
          icon="tags"
          value={absoluteSalesCount}
          label="Gesamtabverkauf in Stück"
        />
        <AnalyticWidget
          icon="eur"
          value={absoluteSalesRevenue}
          label="Gesamtumsatz in Zeitraum"
        />
        <AnalyticWidget
          icon="home"
          value={absoluteSellingMerchantStoreCount}
          label="Anzahl der verkaufenden Märkte"
        />
      </Row>

      <LineCharts
        averageSalesCountPerStorePerWeekChartData={
          averageSalesCountPerStorePerWeekChartData
        }
        averageSalesCountPerStorePerWeek={averageSalesCountPerStorePerWeek}
        absoluteSalesCountPerStorePerWeekChartData={
          absoluteSalesCountPerStorePerWeekChartData
        }
        absoluteSalesCountPerStorePerWeek={absoluteSalesCountPerStorePerWeek}
        averageSalesRevenuePerStorePerWeekChartData={
          averageSalesRevenuePerStorePerWeekChartData
        }
        averageSalesRevenuePerStorePerWeek={averageSalesRevenuePerStorePerWeek}
      />

      <Col xs={6}>
        <h4>∅ Abverkauf kumuliert pro EDEKA Großhandlung (GH)</h4>
        <HorizontalBarChart chartData={averageSalesCountPerRegionChartData} />
      </Col>

      <Col xs={6}>
        <h4>Gesamtabverkauf kumuliert pro EDEKA Großhandlung (GH)</h4>
        <HorizontalBarChart chartData={absoluteSalesCountPerRegionChartData} />
      </Col>
    </div>
  );
}
